import { useCallback, useEffect, useState } from "react";
import http from "../../../../services/http";

export interface SupportPriority {
	id: string;
	code: string;
	label: string;
	color: string | null;
	sortOrder: number;
	isActive: boolean;
}

export function useSupportPriorities() {
	const [priorities, setPriorities] = useState<SupportPriority[]>([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState("");

	const load = useCallback(async () => {
		setLoading(true);
		setError("");
		try {
			const { data } = await http.get("/admin/support-ticket-priorities");
			setPriorities(data.priorities ?? []);
		} catch (e: any) {
			setError(e?.response?.data?.message || e?.message || "Load failed");
		} finally {
			setLoading(false);
		}
	}, []);

	useEffect(() => {
		void load();
	}, [load]);

	const create = async (payload: Omit<SupportPriority, "id">) => {
		await http.post("/admin/support-ticket-priorities", payload);
		await load();
	};

	const update = async (id: string, patch: Partial<Omit<SupportPriority, "id" | "code">>) => {
		await http.patch(`/admin/support-ticket-priorities/${id}`, patch);
		await load();
	};

	const remove = async (id: string, force = false) => {
		const params = force ? { force: "1" } : undefined;
		await http.delete(`/admin/support-ticket-priorities/${id}`, { params });
		await load();
	};

	return { priorities, loading, error, load, create, update, remove };
}
